import { Radio, Select } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faCalendar, faChevronLeft, faClose, faExternalLink, faSearch } from '@fortawesome/free-solid-svg-icons';
import { CaretDownFilled } from "@ant-design/icons";
import { useLazyQuery, useQuery } from "@apollo/client";
import { getCustomerQuery } from '@src/util/query/customer.query';
import { GET_BRANCHES } from "@src/util/query/branch.query";
import { useEffect, useState } from "react";
import { getSiteGroups } from "@src/util/query/siteGroup.query";
import { getAgencies } from "@src/util/query/agency.query";
import { getSitesQuery } from "@src/util/query/site.query";
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import { shiftTypeQuery } from "@src/util/query/shiftType.query";
import { getPayLevelQuery } from "@src/util/query/paylevel.query";
import "./advanceFilter.css";



export const PlainFilter = ({
    handelFilter, clearFilter, 
    handelOption, setFilterValueSearch, 
    filtervalues, filterValueSearch, handelChange, 
    setFilterValues, selectedFilter, singleFilter,
    setFilterEnable, upsertFilter
})=>{
    return(
        <>
        <div className='back-btn' onClick={clearFilter}> <FontAwesomeIcon style={{fontSize: '8px'}} icon={faChevronLeft}/> <span>Back</span> </div>
        <div className="h5">{selectedFilter?.label}</div>
        <div className="text">All filters are in the account's time zone</div>
        <Radio.Group onChange={(e)=>handelFilter(e)} className='advanceFilterRadio'>
            <Radio value={"contain_exactly"}>contains exactly</Radio>
            {singleFilter=="contain_exactly" ? <TagString
                selectedFilter={selectedFilter}
                handelOption={handelOption} handelChange={handelChange} setFilterValues={setFilterValues}
                setFilterValueSearch={setFilterValueSearch} filtervalues={filtervalues} filterValueSearch={filterValueSearch}
            /> : null}
            <Radio value={"not_contain"}>doesn't contain exactly</Radio>
            {singleFilter=="not_contain" ? <TagString 
                selectedFilter={selectedFilter}
                handelOption={handelOption} handelChange={handelChange} setFilterValues={setFilterValues}
                setFilterValueSearch={setFilterValueSearch} filtervalues={filtervalues} filterValueSearch={filterValueSearch}/> : null}
            {
                selectedFilter?.label=="Call Status"? null
                :
                <>
                    <Radio value={"is_known"}>is known</Radio>
                    <Radio value={"is_unknown"}>is unknown</Radio>
                </>
            }
        </Radio.Group>
        <button className='filter-btn' style={{marginTop:'10%'}} onClick={()=>{
            upsertFilter({

                operator: selectedFilter.label, 
                filter:singleFilter, 
                filterValue: filtervalues,
                propId: selectedFilter.id

            });
            setFilterEnable(false);
            setFilterValues([]);
            clearFilter();
        }}>
          Apply filter
        </button>
        </>
    )
}

const TagString = ({selectedFilter, handelOption, handelChange, setFilterValues, setFilterValueSearch, filtervalues, filterValueSearch})=>{
    
    
    const [getCustomer ,{data: customerData, loading: customerLoading}] = useLazyQuery(getCustomerQuery,{
        variables: {
            input: {
                filters: null
            }
        },
        fetchPolicy:'network-only'
      });
      
      const [getBranch, { data: branchData, loading: branchLoading}] = useLazyQuery(GET_BRANCHES)

      const [getSiteGroup, {data: siteGroupData, loading: siteGroupLoading}] = useLazyQuery(getSiteGroups,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null
            }
        }
      });

        // Agency list if needed to load

      const [getAgency, {data: agencyData, loading: agencyLoading, refetch}] = useLazyQuery(getAgencies,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null
            }
        }
      });

      //   site list

      const [getSite ,{data: siteData, loading: siteLoading}] = useLazyQuery(getSitesQuery,{fetchPolicy: 'cache-and-network',
          variables: {
              input: {
                  filters: null
              }
          }
      });

      const [getEmployee,{data: employeeData, loading: employeeDataLoading,}] = useLazyQuery(GetEmployeeRecord,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null
            }
        }
     });

    
    //  pay level
    const {data: dutyTypeData, loading: dutyTypeLoading, refetchDutyType} = useQuery(getPayLevelQuery,{
        fetchPolicy: 'cache-and-network',
    });


    // hour type
    const {data: hourTypeData, loading: hourTypeDataLoading, refetch: refetchHourType} = useQuery(shiftTypeQuery,{
        fetchPolicy: 'cache-and-network',
    });



      const [localGroup, setLocalGroup] = useState(branchData?.branches?.branches||[]);
      useEffect(()=>{
        if(branchData?.branches?.branches){
          setLocalGroup(branchData?.branches?.branches)
        }
      }, [branchData?.branches?.branches]);



    return(
        <div style={{marginBottom:'15px'}} className="advanceFilterSelect">
            {
                selectedFilter?.type=="branch"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    className="custom-select "
                    onSearch={(e)=>getBranch({
                        
                            fetchPolicy: 'cache-and-network',
                            variables: {
                                input: {
                                    filters: {
                                        advanceFilter: [
                                            [{
                                                condition : "and",
                                                filter : "contain_exactly",
                                                filterValue : [e],
                                                operator: "Branch name"
                                            }]
                                        ]
                                    }
                                }
                            }
                        
                    })}

                    placeholder="Branch..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%",}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={branchLoading}
                >
                    {
                        localGroup?.length && localGroup?.map((gl)=>(
                            <Option key={gl._id} value={gl._id}>{gl.branchname}</Option>
                        ))
                    }
                </Select>
                
                :
                selectedFilter?.type=="customer"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Customer..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={customerLoading}
                    onSearch= {(e)=>getCustomer({
                        
                            fetchPolicy: 'cache-and-network',
                            variables: {
                                input: {
                                    filters: {
                                        advanceFilter: [
                                            [{
                                                condition : "and",
                                                filter : "contain_exactly",
                                                filterValue : [e],
                                                operator: "Customer name"
                                            }]
                                        ]
                                    }
                                }
                            }
                        
                    })}
                >
                    {customerData?.customers?.customers?.map((option)=>(<Option value={option._id} label={option?.customername}> {option?.customername} </Option>))}

                </Select>
                :
                selectedFilter?.type=="sitegroup"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Site group..."
                    onSearch= {(e)=>getSiteGroup({
                        
                            fetchPolicy: 'cache-and-network',
                            variables: {
                                input: {
                                    filters: {
                                        advanceFilter: [
                                            [{
                                                condition : "and",
                                                filter : "contain_exactly",
                                                filterValue : [e],
                                                operator: "Site Group Name"
                                            }]
                                        ]
                                    }
                                }
                            }
                        
                    })}

                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={siteGroupLoading}
                >
                    {siteGroupData?.sitegroups?.sitegroups?.map((option)=>(<Option value={option._id} label={option?.sitegroupname}> {option?.sitegroupname} </Option>))}

                </Select>
                :
                selectedFilter?.type=="site"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Site..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={siteLoading}

                    onSearch= {(e)=>getSite({
                        
                        fetchPolicy: 'cache-and-network',
                        variables: {
                            input: {
                                filters: {
                                    advanceFilter: [
                                        [{
                                            condition : "and",
                                            filter : "contain_exactly",
                                            filterValue : [e],
                                            operator: "Site name"
                                        }]
                                    ]
                                }
                            }
                        }
                    
                    })}

                >
                    {siteData?.sites?.sites?.map((option)=>(<Option value={option._id} label={option?.sitename}> {option?.sitename} </Option>))}
                    
                </Select>
                :
                selectedFilter?.type=="agency"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Supplier..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={agencyLoading}

                    onSearch= {(e)=>getAgency({
                        
                        fetchPolicy: 'cache-and-network',
                        variables: {
                            input: {
                                filters: {
                                    advanceFilter: [
                                        [{
                                            condition : "and",
                                            filter : "contain_exactly",
                                            filterValue : [e],
                                            operator: "supplier name"
                                        }]
                                    ]
                                }
                            }
                        }
                    
                    })}
                >
                    {agencyData?.agencies?.agencies?.map((option)=>(<Option value={option._id} label={option?.suppliername}> {option?.suppliername} </Option>))}
                    
                </Select>
                :
                selectedFilter?.type=="employee"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Employee..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={employeeDataLoading}

                    onSearch= {(e)=>getEmployee({
                        
                        fetchPolicy: 'cache-and-network',
                        variables: {
                            input: {
                                filters: {
                                    advanceFilter: [
                                        [{
                                            condition : "and",
                                            filter : "contain_exactly",
                                            filterValue : [e],
                                            operator: "first name"
                                        }],

                                        [{
                                            condition : "and",
                                            filter : "contain_exactly",
                                            filterValue : [e],
                                            operator: "last name"
                                        }]
                                    ]
                                }
                            }
                        }
                    
                    })}

                >
                    {employeeData?.getEmployee?.response?.map((option)=>(<Option value={option._id} label={option?.firstname}> {option?.firstname} {option?.lastname} </Option>))}
                    
                </Select>
                :
                selectedFilter?.type=="dutytype"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Duty Type..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={dutyTypeLoading}
                >
                    {dutyTypeData?.getPayLevel?.response?.map((dutyType)=>(<Option value={dutyType._id} label={dutyType?.name}> {dutyType?.name} </Option>))}
                    
                </Select>
                :
                selectedFilter?.type=="hourtype"?  
                
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Hour Type..."
                    style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                    value={filtervalues}
                    suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                    onChange={(e)=>setFilterValues([e])}
                    loading={hourTypeDataLoading}
                >
                    {hourTypeData?.getShiftType?.response?.map((option)=>(<Option value={option._id} label={option?.name}> {option?.name}</Option>))}
                    
                </Select>

                :selectedFilter?.prop?.options?
                    <Select
                        className='custom-select ' 
                        style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                        value={filtervalues}
                        suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                        onChange={(e)=>setFilterValues([e])}
                    >
                        {selectedFilter?.prop?.options?.map((option)=>(
                            <Option value={option?.value}>{option?.key}</Option>
                        ))}
                    </Select>
                :
                <>
                    <Select 
                        mode='tags' 
                        className='custom-select ' 
                        style={{width:'100%',marginTop:"1%", marginBottom:"2%"}} 
                        value={filtervalues}
                        onSearch={(e)=>setFilterValueSearch(e)}
                        onInputKeyDown={(e)=>{if(e.key==="Enter"){setFilterValues([...filtervalues, filterValueSearch]);setFilterValueSearch("")}}}
                        open={false}
                        suffixIcon={<CaretDownFilled style={{color:'#0091ae'}} />}
                        onChange={handelChange}
                    />
                    {
                        filterValueSearch ?
                        <div className='createOption text'  style={{marginBottom:'0',marginTop:'-0.6%', color: ""}}>
                            <span onClick={handelOption}> Create option as "{filterValueSearch}"  </span><FontAwesomeIcon icon={faClose} onClick={()=>setFilterValueSearch(null)}/>
                        </div> : null
                    }
                </>
            }
        </div>
    );
}